<template>
  <el-dialog
    title="选择产品"
    :visible="visible"
    @close="onClose"
    width="60%"
    top="5vh"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="top">
      <div>
        <!-- <select2
          labelName="NameNumber"
          v-model="former.DciProductModelID"
          url="dci/model/product/list?order=name"
          clearable
          placeholder="产品型号名称"
          no-data-text="没有产品型号名称"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2> -->
        <el-select
          v-model="former.dciProductModelName"
          clearable
          placeholder="选择产品型号"
          style="width: 250px"
        >
          <el-option
            v-for="ele in modelList"
            :key="ele"
            :label="ele"
            :value="ele"
          >
          </el-option> </el-select
        >&nbsp;
        <!-- <select2
          labelName="SN"
          v-model="former.ID"
          :url="productUrl"
          placeholder="请选择产品SN"
          no-data-text="无产品"
          :urlParams="{
            where: {},
          }"
          q="SN:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp; -->
        <el-input
          v-model.trim="former.key"
          placeholder="请输入点位名称或MN或产品SN"
          @keydown.enter.native="onSubmitQuery"
          style="width: 220px"
        >
        </el-input
        >&nbsp;
        <el-select
          v-model="former.heartbeat"
          clearable
          placeholder="在线状态"
          style="width: 100px"
        >
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="0"></el-option>
        </el-select>
        &nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-fw fa-search"></i>
        </el-button>
      </div>
    </div>

    <el-table
      ref="tb"
      :data="itemList"
      v-loading="loading"
      :row-key="getRowKey"
      @selection-change="onSelectChanged"
    >
      <el-table-column
        type="selection"
        width="55"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column
        prop="DciProductModel.NameNumber"
        label="产品型号名称"
      ></el-table-column>
      <el-table-column prop="SN" label="产品SN"
        ><template slot-scope="scope">
          <el-tag v-if="scope.row.SN">
            {{ scope.row.SN }}
          </el-tag>
          <el-tag type="success" v-if="scope.row.Remark">
            {{ scope.row.Remark }}
          </el-tag>
        </template></el-table-column
      >
      <el-table-column
        prop="DciStation.Name"
        label="点位名称"
      ></el-table-column>
      <el-table-column width="80" align="center" label="在线状态">
        <template slot-scope="scope">
          <el-tooltip content="Top center" placement="top" effect="light">
            <div slot="content" v-if="scope.row.HeartBeat === true">
              <div v-if="scope.row.HeartBeatAt">
                在线:{{ scope.row.HeartBeatAt }}
              </div>
              <div v-else>在线</div>
            </div>
            <div slot="content" v-else>
              <div v-if="scope.row.HeartBeatAt">
                离线:{{ scope.row.HeartBeatAt }}
              </div>
              <div v-else>离线</div>
            </div>
            <i
              class="fa fa-wifi fa-lg"
              style="color: #92c655; cursor: pointer"
              v-if="scope.row.HeartBeat === true"
            ></i>
            <i
              class="fa fa-wifi fa-lg"
              style="color: #f0615e; cursor: pointer"
              v-else
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="onSubmit">
        <i class="far fa-save"></i> 确 定
      </el-button>
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      itemList: [],
      former: {
        DciProductModelID: "",
        ID: "",
        key: "",
        heartbeat: "", //在线状态 0：离线，1：在线，过滤显示在线的产品
      },
      pager: {
        total: 0,
        page: 1,
        size: 10,
      },
      options: [],
      loading: false,
      productUrl: "dci/product/stock-list/list?order=-sn",
      modelList: [], //产品型号
    };
  },
  mounted() {
    this.getModelList();
    this.getItemList();
  },
  watch: {
    "former.dciProductModelName": {
      handler() {
        // this.productUrl = `dci/station?where[DciProductModelID]=${this.former.DciProductModelID}&order=-sn`;
        this.productUrl = `dci/station?dciProductModelName=${this.former.dciProductModelName}&order=-sn`;
      },
    },
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/station", {
          params: {
            where: {
              // DciProductModelID: this.former.DciProductModelID,
              ID: this.former.ID,
            },
            key: this.former.key,
            dciProductModelName: this.former.dciProductModelName,
            heartbeat: this.former.heartbeat,
            ...this.pager,
            with: ["DciStation", "DciProductModel"],
            order: ["-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
          if (this.pager.page > response.data.last) {
            this.pager.page = response.data.last;
            this.getItemList();
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("dci/model/product/name/list").then(
        (response) => {
          this.modelList = response.data;
          // this.modelList.push({
          //   ID: 0,
          //   NameNumber: "其它类型",
          // });
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onSelectChanged(options) {
      this.options = options;
    },
    // 选择产品
    onSubmit() {
      this.$emit("update", this.options);
      this.onClose();
    },
    // 关闭
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.tb.clearSelection();
    },
    getRowKey(row) {
      return row.ID;
    },
  },
};
</script>

<style scoped lang="scss">
.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 12px 10px 10px 30px;
  margin: -30px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 20%;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
}
</style>
